var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSignal = function SvgSignal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#64BE3C",
    fillRule: "evenodd",
    d: "M9 2.25a.75.75 0 0 0-.75.75v11.49c0 .412.338.75.75.75s.75-.338.75-.75V3A.75.75 0 0 0 9 2.25m3 3a.75.75 0 0 0-.75.75v6c0 .412.338.75.75.75s.75-.338.75-.75V6a.75.75 0 0 0-.75-.75M5.25 6c0-.412.338-.75.75-.75s.75.338.75.75v6c0 .412-.338.75-.75.75a.75.75 0 0 1-.75-.75zM3 6.75a.75.75 0 0 0-.75.75v2.25c0 .412.337.75.75.75s.75-.338.75-.75V7.5A.75.75 0 0 0 3 6.75m11.25.75c0-.412.338-.75.75-.75s.75.338.75.75v2.25c0 .412-.338.75-.75.75a.75.75 0 0 1-.75-.75z",
    clipRule: "evenodd"
  })));
};
export default SvgSignal;